// ===== Styling for smile widget start =====
(function () {
  window.addEventListener("load", () => {
    const LAUNCHER_SIZE = "48px";

    const frameContainerStyles = {
      width: LAUNCHER_SIZE,
      height: LAUNCHER_SIZE,
    };

    const launcherStyles = {
      width: LAUNCHER_SIZE,
      height: LAUNCHER_SIZE,
      "min-width": LAUNCHER_SIZE,
      "border-radius": "50%",
      padding: "0",
      "justify-content": "center",
      "align-items": "center",
    };

    const closeIconStyles = {
      margin: "auto",
    };

    function applyStyles(element, styles) {
      for (const [prop, value] of Object.entries(styles)) {
        element.style.setProperty(prop, value, "important");
      }
    }

    function isMobile() {
      return window.innerWidth <= 749;
    }

    function applyWidgetStyles() {
      const uiContainer = document.getElementById("smile-ui-container");
      if (!uiContainer) return false;

      const frameContainer = uiContainer.querySelector(
        ".smile-launcher-frame-container",
      );
      const smileFrame = uiContainer.querySelector(
        "iframe.smile-launcher-frame",
      );

      if (!frameContainer || !smileFrame) return false;

      applyStyles(frameContainer, frameContainerStyles);

      let iframeDoc;
      try {
        iframeDoc =
          smileFrame.contentDocument || smileFrame.contentWindow?.document;
      } catch {
        return true;
      }

      if (!iframeDoc) return false;

      const innerLauncher = iframeDoc.querySelector(".launcher-container");
      if (!innerLauncher) return false;

      applyStyles(innerLauncher, launcherStyles);

      const closeIcon = iframeDoc.querySelector(
        ".launcher-container .launcher-close-icon",
      );
      if (closeIcon) applyStyles(closeIcon, closeIconStyles);

      return true;
    }

    function waitForWidget() {
      if (!isMobile()) return;

      const observer = new MutationObserver(() => {
        if (applyWidgetStyles()) {
          observer.disconnect();
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });

      if (applyWidgetStyles()) {
        observer.disconnect();
      }
    }

    const mobileQuery = window.matchMedia("(max-width: 749px)");
    mobileQuery.addEventListener("change", (e) => {
      if (e.matches) waitForWidget();
    });

    waitForWidget();
  });
})();
// ===== Styling for smile widget end =====
